function normalize (raw) {
  const chars = {
    á: 'a',
    é: 'e',
    í: 'i',
    ó: 'o',
    ú: 'u',
    à: 'a',
    è: 'e',
    ì: 'i',
    ò: 'o',
    ù: 'u',
  };
  const expr = /[áàéèíìóòúù]/gi;
  const normalized = raw.toLowerCase().replace(expr, char => chars[char]);
  return normalized;
}

export default function filterBySomeValues (query, ...values) {
  return values.some(value => normalize(value).includes(normalize(query)));
}
